import { render, staticRenderFns } from "./AppDropdownItem.vue?vue&type=template&id=fe6c4272&"
import script from "./AppDropdownItem.vue?vue&type=script&lang=js&"
export * from "./AppDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports